import type { ComponentProps, ReactNode } from 'react'
import { ExternalLink } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface CobaltLaunchButtonProps
  extends Pick<ComponentProps<typeof Button>, 'size' | 'className'> {
  isStarting: boolean
  onClick: () => void
  children: ReactNode
}

export function CobaltLaunchButton({
  isStarting,
  onClick,
  children,
  size,
  className,
}: CobaltLaunchButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      className={className}
      disabled={isStarting}
      onClick={onClick}>
      {isStarting ? 'Opening…' : children}
      {!isStarting && <ExternalLink aria-hidden="true" />}
    </Button>
  )
}
